/* 🤖 this file was generated by svg-to-ts */
export const svgX: {
    name: "x";
    data: string;
} = {
    name: "x",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__x" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M17.9816 24.8761L0 2H14.2427L25.3426 16.139L37.2011 2.06366H45.0452L29.1352 20.9701L48 45H33.7998L21.7809 29.7095L8.94951 44.9576H1.06289L17.9816 24.8761ZM35.8696 40.7615L8.73314 6.23854H12.1713L39.2736 40.7615H35.8696Z" clip-rule="evenodd"/></symbol></svg>`,
};
